import React, { FunctionComponent } from 'react'
import Svg, { G, Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraCaregiverTrainingForNeuroSpotIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M32.225 0.239258C27.8073 0.239258 23.5212 0.996819 19.4855 2.49044C9.87754 6.05186 3.12272 13.9474 0.952482 24.1524C-0.481698 30.806 -0.298315 36.9601 1.51654 42.9574C3.83349 50.6164 9.52089 57.0753 17.1205 60.6772C20.8932 62.4693 25.2273 63.4925 30.0003 63.7176C30.6137 63.7454 31.2372 63.7606 31.8569 63.7606C35.6865 63.7606 39.5388 63.2357 43.3076 62.2012C43.5972 62.1291 43.8729 62.0545 44.1638 61.9685C47.5507 60.9769 50.5987 59.4087 53.2065 57.3131C56.0382 55.0505 58.369 52.1822 60.127 48.7927C60.4735 48.125 60.8049 47.4218 61.1704 46.5808C63.1812 41.9114 64.1525 36.6844 63.9805 31.4586C63.8996 29.148 63.5556 26.6919 62.9612 24.1524C61.9823 20.032 60.3862 16.1569 58.345 12.9395C57.786 12.0757 57.2725 11.3497 56.7641 10.6971C53.0952 5.9646 47.3787 2.64347 40.2382 1.098C37.6151 0.631554 34.9188 0.240522 32.2262 0.240522L32.225 0.239258Z'
        fill={spotIllustration.background.fill}
      />
      <G>
        <Path
          d='M14.3757 50.9092C13.0205 50.9092 11.9369 49.5829 12.0029 47.9986C12.2084 43.1269 11.2821 33.8223 14.9188 30.2821C16.142 29.0925 18.8904 27.1418 20.2862 27.7301C25.2374 29.8176 26.8997 28.2901 28.8309 27.7946C30.7165 27.3095 33.4548 29.7608 34.442 31.3039C36.6701 34.7796 35.8149 43.5295 35.8758 48.0837C35.8961 49.6371 34.8277 50.9092 33.5004 50.9092H14.3757Z'
          fill={spotIllustration.secondary.fill}
        />
        <Path
          d='M31.4075 19.8121C31.4075 23.393 28.4983 26.6241 24.9108 26.6241C21.3233 26.6241 18.4141 23.393 18.4141 19.8121C18.4141 16.2312 21.3233 13 24.9108 13C28.4983 13 31.4075 16.2312 31.4075 19.8121Z'
          fill={spotIllustration.secondary.fill}
        />
        <Path
          d='M34.8274 50.9995C33.7513 50.9995 32.8885 49.9467 32.9418 48.685C33.1068 44.8145 32.3683 37.4218 35.2588 34.6093C36.2308 33.6623 38.4158 32.1141 39.5248 32.5837C43.4584 34.2429 44.7806 33.0275 46.3134 32.6353C47.8462 32.2431 49.9881 34.1964 50.7723 35.4221C52.5411 38.183 51.8635 45.137 51.9117 48.7546C51.9295 49.988 51.0793 50.9995 50.0262 50.9995H34.8274Z'
          fill={spotIllustration.primary.fill}
        />
        <Path
          d='M48.0533 26.2108C48.0533 29.0315 45.6899 31.5779 42.7747 31.5779C39.8594 31.5779 37.4961 29.0315 37.4961 26.2108C37.4961 23.3901 39.8594 20.8438 42.7747 20.8438C45.6899 20.8438 48.0533 23.3901 48.0533 26.2108Z'
          fill={spotIllustration.primary.fill}
        />
      </G>
    </Svg>
  )
}
